module.exports = __webpack_public_path__ + "img/addnew.3a16130f.svg";